import { render } from "./BaseImageElement.vue?vue&type=template&id=0b1f9460&scoped=true&ts=true"
import script from "./BaseImageElement.vue?vue&type=script&lang=ts"
export * from "./BaseImageElement.vue?vue&type=script&lang=ts"

import "./BaseImageElement.vue?vue&type=style&index=0&id=0b1f9460&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1f9460"]])

export default __exports__